import {Component, Input, OnInit} from '@angular/core';
import {Job} from '../model/job';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-job-item',
  templateUrl: './job-item.component.html',
  styleUrls: ['./job-item.component.css']
})
export class JobItemComponent implements OnInit {

  @Input()
  job: Job;

  loading = false;

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  openJob() {
    const url = '/ais/rest/portal/pracovne-ponuky/detail/' + this.job.id;
    const top  = (screen.height / 2) - 300;
    const left = (screen.width / 2) - 300;

    this.loading = true;

    this.http.get(url, {responseType: 'text'})
      .subscribe({
        next: (data) => {
          const win = window.open('', 'Title', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=600,top=' + top + ',left=' + left);
          win.document.body.innerHTML = data;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching job details:', error);
          this.loading = false;
        }
      });

  }

}
